import React from 'react';
import { Animate } from 'react-move';
import * as d3 from 'd3';
import { easeCubicInOut } from 'd3-ease';
import { Waypoint } from 'react-waypoint';
export default class Card extends React.Component {
  state = {
    expand: this.props.expand,
    appear: this.props.appear
  };

  componentWillUpdate(nextProps) {}

  handleExpand = () => {
    this.setState({ expand: !this.state.expand });
  };

  headerHeight = 40;
  maxHeight = this.props.maxHeight;

  get stepFn() {
    return this.props.stepIndex === this.props.step
      ? this.props.handleScrollIn
      : () => {};
  }
  handleStep = () => {
    if (this.props.step !== this.props.stepIndex) {
      this.props.handleStepSet(this.props.stepIndex, false, false);
    }
  };

  render() {
    const {
      helperText,
      config,
      appear,
      cardComponentStyle,
      scrollOut,
      handleScrollOut,
      handleStepSet,
      step,
      stepIndex,
      disableWaypoint
    } = this.props;
    const { headerHeight, handleExpand, maxHeight } = this;
    const { expand } = this.state;
    const isRiderFriendly = !!(config && config === 'Rider Friendly');
    const open = !isRiderFriendly && expand;
    return (
      <div
        className='card-container'
        onMouseDown={this.handleStep}
        style={{ display: !appear ? 'none' : null }}
      >
        <Animate
          show={appear}
          start={() => {
            return {
              height: open ? maxHeight : isRiderFriendly ? 0 : headerHeight,
              opacity: 0
            };
          }}
          enter={() => {
            return {
              height: [open ? maxHeight : isRiderFriendly ? 0 : headerHeight],
              opacity: [1],
              timing: { duration: 800, ease: easeCubicInOut },
              events: {
                start: this.stepFn
              }
            };
          }}
          update={() => {
            return {
              opacity: [1],
              height: [open ? maxHeight : isRiderFriendly ? 0 : headerHeight],
              timing: { duration: 800, ease: easeCubicInOut },
              events: {
                start: this.stepFn
              }
            };
          }}
          leave={() => {
            return {
              height: [0],
              opacity: [0],
              timing: { duration: 800, ease: easeCubicInOut },
              events: {
                start: scrollOut ? handleScrollOut : () => {}
              }
            };
          }}
        >
          {({ height, opacity }) => {
            return (
              <div
                className='card-item full'
                style={{
                  minHeight: height + 'px',
                  height: height + 'px',
                  paddingTop: appear ? '0px' : '0px',
                  overflow:
                    height + 'px' === this.maxHeight ? 'auto' : 'hidden',
                  opacity
                }}
              >
                <header
                  className='card-header'
                  style={{ height: headerHeight, zIndex: 10 }}
                  onClick={handleExpand}
                >
                  {this.props.header}
                  <div
                    className='caret'
                    style={{
                      marginLeft: '10px',
                      position: 'absolute',
                      right: '20px',
                      fontSize: '10px'
                    }}
                  >
                    {expand ? '▲' : '▼'}
                  </div>
                </header>
                <div
                  className='card-content card-component-content'
                  ref={(node) => {
                    this.cardcontent = node;
                  }}
                  style={cardComponentStyle}
                >
                  <Waypoint
                    scrollableAncestor={document.getElementById('full-app')}
                    topOffset={100}
                    bottomOffset={100}
                    onEnter={(event) => {
                      if (step !== stepIndex && !disableWaypoint) {
                        // handleStepSet(stepIndex, true);
                      }
                    }}
                    onLeave={(event) => {
                      // console.log('keft', event);
                    }}
                  />
                  {this.props.content}
                </div>
                {helperText && (
                  <div
                    className='explainer-text'
                    style={{
                      position: 'absolute',
                      bottom: 0,
                      zIndex: open ? 1 : null
                    }}
                  >
                    {helperText}
                  </div>
                )}
              </div>
            );
          }}
        </Animate>
      </div>
    );
  }
}

Card.defaultProps = {
  expand: false,
  maxHeight: 580,
  header: 'add a header prop',
  content: ''
};



// WEBPACK FOOTER //
// ./src/components/Controls/Card/index.js